import { DeactivateProductModal } from 'commerce-products-lib/products/DeactivateProductModal';
import { toNumberOrUndefined } from 'commerce-products-lib/utils/toNumber';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useObjectId } from './useObjectId';
import { useObjectTypeId } from './useObjectTypeId';
import { useProductAssociatedBundles } from './useProductAssociatedBundles';
import { useProperty } from './useProperty';
import { jsx as _jsx } from "react/jsx-runtime";
export const useValidateBundleAssociation = onChange => {
  const property = useProperty();
  const objectId = useObjectId();
  const objectTypeId = useObjectTypeId();
  const numberObjectId = toNumberOrUndefined(objectId);
  const [hasBeenDeactivatedWithBundles, setHasBeenDeactivatedWithBundles] = useState(false);
  const isEligibleProduct = objectTypeId === PRODUCT_TYPE_ID && numberObjectId != null;
  const isEligibleProperty = property.name === 'hs_status';
  const {
    data: associatedBundles,
    loading
  } = useProductAssociatedBundles(objectId, !isEligibleProduct || !isEligibleProperty);
  const hasAnyBundles =
  // Deactivated products are removed from their bundles
  !hasBeenDeactivatedWithBundles && associatedBundles && associatedBundles.length > 0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const cachedChangesRef = useRef();
  const onChangeWithBundleAssociationValidation = useCallback(changes => {
    if (isEligibleProduct && isEligibleProperty && changes['hs_status'] === 'inactive' && !loading && hasAnyBundles) {
      cachedChangesRef.current = changes;
      setIsModalOpen(true);
    } else {
      return onChange(changes);
    }
  }, [hasAnyBundles, isEligibleProduct, isEligibleProperty, loading, onChange]);
  const onConfirm = useCallback(() => {
    if (cachedChangesRef.current) {
      onChange(cachedChangesRef.current);
      setHasBeenDeactivatedWithBundles(true);
    }
    cachedChangesRef.current = undefined;
    setIsModalOpen(false);
  }, [onChange]);
  const onReject = useCallback(() => {
    cachedChangesRef.current = undefined;
    setIsModalOpen(false);
  }, []);
  const deactivateProductModal = useMemo(() => isModalOpen && numberObjectId != null ? /*#__PURE__*/_jsx(DeactivateProductModal, {
    onConfirm: onConfirm,
    onReject: onReject,
    productId: numberObjectId,
    associatedBundles: associatedBundles
  }) : undefined, [associatedBundles, isModalOpen, numberObjectId, onConfirm, onReject]);
  return {
    onChangeWithBundleAssociationValidation,
    deactivateProductModal
  };
};